<div class="d-flex flex-column">
  <header class="container-fluid bg-app-secondary px-5 py-4 position-relative">
    <div class="row">
      <div class="col-12">
        <h1 class="text-dark my-2 h5">
          Reset Passwords
        </h1>
      </div>
    </div>
    <!-- close icon -->
    <div>
      <button tabindex="-1" mat-button mat-dialog-close class="close-icon position-absolute">
        <i class="bi bi-x-circle-fill h3"></i>
      </button>
    </div>
  </header>
  <section class="container-fluid bg-white p-5">
    <div class="row">
      <form class="col-12" [formGroup]="forgotFormgroup" (ngSubmit)="handleSumbit()">
        <div class="mb-3">
          <input type="email" formControlName="email" placeholder="Enter Your Email" class="form-control">
        </div>
        <div class="text-center">
          <button [disabled]="forgotFormgroup.invalid" class="btn px-4 app-btn-dark">SEND</button>
        </div>
      </form>
    </div>
  </section>
</div>
